module.exports = __webpack_public_path__ + "static/media/facebook.e0ef66ff.svg";